import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './BlogPage.module.css';

const BlogPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Blog — Brands2Buyers</title>
        <meta property="og:title" content="Blog — Brands2Buyers" />
        <meta name="twitter:title" content="Blog — Brands2Buyers" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <section className={styles.header}>
        <h1 className={styles.title}>Blog</h1>
      </section>

      <section className={styles.content}>
        <div className={styles.container}>
          <p className={styles.text}>
            Aucun article pour le moment. Revenez bientôt pour découvrir nos dernières actualités.
          </p>
        </div>
      </section>
    </>
  );
};

export default BlogPage;
